import { render, staticRenderFns } from "./typepriceattr.vue?vue&type=template&id=094f58bf&"
import script from "./typepriceattr.vue?vue&type=script&lang=js&"
export * from "./typepriceattr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports